// react
import { useContext } from 'react';

// mui
import { Container, Grid } from '@mui/material';

// tables
import { TableDocuments } from '../../../tables/cards/TableDocuments/TableDocuments';

// context
import { ContextEntityDocuments } from '../Entity.context';

export const Documents = () => {
	// context
	const { documents, isLoadingDocuments, paginationDocuments, refetchDocuments } =
		useContext(ContextEntityDocuments);

	return (
		<Container maxWidth={false}>
			<Grid container spacing={2}>
				<Grid item xs={12}>
					<TableDocuments
						documents={documents}
						frame="ENTITY"
						isLoading={isLoadingDocuments}
						pagination={paginationDocuments}
						refetchDocuments={refetchDocuments}
					/>
				</Grid>
			</Grid>
		</Container>
	);
};
